import { InputStateType } from '~src/domains/common/types/forms';

export enum AcceptSubPage {
  OFFERS = 'offers',
  PAYMENT_METHODS = 'payment-methods',
}

export type AcceptState = {
  paymentSelectorError: string | null; // The i18n key for the error message
  subPage: AcceptSubPage;
};

export type AcceptFormState = {
  'card-info-number': InputStateType;
  'card-info-expiration': InputStateType;
  'card-info-ccv': InputStateType;
  'billing-zip': InputStateType;
  'card-info-name': InputStateType;
  'full-ssn': InputStateType;
  autopay: InputStateType;
};
